import { Id } from 'react-toastify'
import { Toast } from './types'
import { OrdersUpdatedAction } from '../order/actions'

export const addToast = (toast: Toast) =>
  ({ type: 'toasts.AddToast', payload: toast } as const)
export type AddToastAction = ReturnType<typeof addToast>

export const removeToast = (toastId: Id) =>
  ({ type: 'toasts.RemoveToast', payload: toastId } as const)
export type RemoveToastAction = ReturnType<typeof removeToast>

export const clearToasts = () => ({ type: 'toasts.ClearToasts' } as const)
export type ClearToastsAction = ReturnType<typeof clearToasts>

export type ToastAction =
  | AddToastAction
  | RemoveToastAction
  | ClearToastsAction
  | OrdersUpdatedAction
